import React, { Component, useState } from "react";
import "leaflet/dist/leaflet.css";
import ReactApexChart from 'react-apexcharts';

export default function Competitor() {
    const handleLogout = (event) => {
        event.preventDefault();
        sessionStorage.clear('token')
        window.location = '/login'
    }

    const betagroPieChart = {
        chart: {
            type: 'pie',
        },
        series: [68, 32],
        labels: ['ใช้ในเครือ', 'ขายลูกค้า'],
        colors: ['#1d3e7b', '#f4823c']
    };

    return (
        <div>
            <div className='navbar'>
                <a href="/home">
                    <img className="cpf-logo" src="/assets/cpf-logo.jpg" />
                </a>
                <button className="logout-btn" onClick={handleLogout}>
                    Log out
                </button>
            </div>
            <div className="global-market-container">
                ภาวะการแข่งขัน
                <ReactApexChart options={betagroPieChart} series={betagroPieChart.series} type="pie" height={350} />
            </div>
        </div>
    );
}

